import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ stat }) => {
  const getChangeColor = (change) => {
    if (change > 0) return 'text-success';
    if (change < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = (change) => {
    if (change > 0) return 'TrendingUp';
    if (change < 0) return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-[var(--color-card)] rounded-lg p-6 shadow-conservation border border-[var(--color-border)]">
      <div className="flex items-start justify-between mb-4">
        <div className={`${stat?.iconBg} rounded-full p-3`}>
          <Icon name={stat?.icon} size={24} className={stat?.iconColor} />
        </div>
        {stat?.change !== undefined && (
          <div className={`flex items-center gap-1 ${getChangeColor(stat?.change)}`}>
            <Icon name={getChangeIcon(stat?.change)} size={16} />
            <span className="text-sm font-medium">{Math.abs(stat?.change)}%</span>
          </div>
        )}
      </div>
      <div className="flex-1">
        <p className="text-sm text-[var(--color-muted-foreground)] mb-1">{stat?.label}</p>
        <p className="text-2xl font-bold text-[var(--color-foreground)]">{stat?.value}</p>
        {stat?.change && (
          <p className={`text-xs mt-1 flex items-center gap-1 ${
            stat?.changeType === 'positive' ? 'text-success' :
            stat?.changeType === 'negative' ? 'text-error' : 'text-[var(--color-foreground)]'
          }`}>
            {stat?.change}%
          </p>
        )}
      </div>
    </div>
  );
};

export default StatCard;